//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet, axiosPost } from '../../../../axios/axios.js'
import WorkQualityCoordinationDialogWithTextAndMedia from '../../../../forms/WorkQuality/WorkQualityCoordinationDialogWithTextAndMedia.vue'
import { formatConfiguredTime, formatDate } from '../../../../components/helpers'
import { EventBus } from '../../../../EventBus/EventBus'
import FilesGroup from '../../../../components/File/FilesGroup'
import FilesField from '../../../../components/File/FilesField.vue'
import ReadonlyDocumentsField from '../../../../components/File/ReadonlyDocumentsField.vue'

export default {
  components: {
    FilesField,
    ReadonlyDocumentsField
  },
  props: {
    objectSrc: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      fullMode: {},
      fullModeAll: false,
      formatConfiguredTime,
      formatDate,

      revisionDeadlineDateTime: {},
      revisionDeadlineRemainingTime: {},
      revisionDeadlineTimer: null,

      reports: [],
      alreadyViewedReports: [],
      employeeIdLocal: (this.objectSrc ? this.objectSrc.id : null) || (this.$store.getters.getUser.employee ? this.$store.getters.getUser.employee.id : null)
    }
  },
  computed: {
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    userCanRequestRevision: function () {
      if (this.$d_hasFullAccess()) {
        return true
      }
      const currentEmployee = this.$store.getters.getUser.employee
      return currentEmployee && currentEmployee.id === this.employeeIdLocal
    },
    userCanCommentRevision: function () {
      return this.userCanRequestRevision
    },
    reportsWithCoordinationsToShow: function () {
      return this.reports.filter(report => report.coordinations && report.coordinations.length)
    }
  },
  watch: {
    fullMode: {
      handler: function (val) {
        localStorage.setItem('userFaultiesFullMode', JSON.stringify(val))
      },
      deep: true
    },
    fullModeAll: function (val) {
      this.reports.forEach(report => {
        this.$set(this.fullMode, report.reportId, val)
      })
    }
  },
  mounted: function () {
    this.faulties = this.getFaulties()
    this.revisionDeadlineTimer = setInterval(() => {
      this.calculateRevisionDeadlineTimes()
    }, 1000 * 60)
    EventBus.$on('update-mobile', this.getFaulties)
  },
  beforeDestroy: function () {
    this.revisionDeadlineTimer && clearInterval(this.revisionDeadlineTimer)
    EventBus.$off('update-mobile', this.getFaulties)
  },
  methods: {
    getFaulties: function () {
      if (!this.employeeIdLocal) {
        return
      }
      return axiosGet({
        url: `/service/delta/workqualityreview/getfaulties?employeeId=${this.employeeIdLocal}`,
        // data: {}
        onSuccess: (response) => {
          this.reports = response.data.sort((a, b) => new Date(b.startReviewTime) - new Date(a.startReviewTime))
          const reportsIds = this.reports.map(report => report.reportId)
          const savedFullModes = JSON.parse(localStorage.getItem('userFaultiesFullMode')) || {}
          reportsIds.forEach(reportId => {
            this.$set(this.fullMode, reportId, savedFullModes[reportId] || false)
          })
          this.calculateRevisionDeadlineTimes()
          if (!this.objectSrc) { // Не отслеживать просмотренные отчеты в карточке сотрудника
            this.alreadyViewedReports = JSON.parse(localStorage.getItem('alreadyViewedReports')) || {}
          }
          if (!this.objectSrc) { // Не отслеживать просмотренные отчеты в карточке сотрудника
            localStorage.setItem('alreadyViewedReports', JSON.stringify(this.getAlreadyViewedReports()))
          }
        }
      })
    },
    getAlreadyViewedReports: function () {
      const result = {}
      this.reports.forEach(r => {
        result[r.reportId] = {}
        r.coordinations.forEach(c => {
          const faulty = r.faulties.find(f => f.faultyType === c.faultyType)
          result[r.reportId][c.recordId] = faulty ? faulty.name : null
          const notes = this.getCoordinationNotes(r, c)
          notes.forEach(n => {
            result[r.reportId][n.time] = n.text
          })
        })
      })
      return result
    },
    getCoordinationNotes: function (report, coordination) {
      return report.notesHistory.filter(n => n.recordId === coordination.recordId && (n.eventType.includes('Комментарий ответственного') || n.eventType.includes('Изменен') || n.requestToResponsible))
    },
    hasUnwatchedChanges: function (report) {
      if (!this.alreadyViewedReports[report.reportId]) {
        return true
      }
      return this.getChangedCoordinationsIds(report).length || this.getChangedNotesTimes(report).length
    },
    getChangedCoordinationsIds: function (report) {
      return report.coordinations.filter(coordination => {
        const faulty = report.faulties.find(f => f.faultyType === coordination.faultyType)
        if (!this.alreadyViewedReports[report.reportId] || this.alreadyViewedReports[report.reportId][coordination.recordId] === undefined || this.alreadyViewedReports[report.reportId][coordination.recordId] !== (faulty ? faulty.name : null)) {
          return true
        }
        return false
      }).map(coordination => coordination.recordId)
    },
    getChangedNotesTimes: function (report) {
      const notes = report.coordinations.map(c => this.getCoordinationNotes(report, c)).flat()
      return notes.filter(n => {
        if (!this.alreadyViewedReports[report.reportId] || !this.alreadyViewedReports[report.reportId][n.time]) {
          return true
        }
        return false
      }).map(n => n.time)
    },
    getCoordinationToolbarClass: function (coordination) {
      switch (coordination.revisionStatus) {
        case 'undefined':
          return 'grey-6'
        case 'requested':
          return 'orange-4'
        case 'executed':
          return 'purple-6'
        case 'finished':
          return 'green-6'
      }
    },
    getCoordinationRevisionStateAlias: function (coordination) {
      switch (coordination.revisionStatus) {
        case 'undefined':
          return 'Пересмотр не выполнялся'
        case 'requested':
          return 'Запрошен пересмотр'
        case 'executed':
          return `Выполняется пересмотр (${coordination.employeeRole})`
        case 'resumed':
          return `Возобновлен пересмотр (${coordination.employeeRole})`
        case 'finished':
          return `Пересмотр завершен (${coordination.employeeRole})`
      }
    },
    getFaultyAlias: function (report, coordination) {
      const faulty = report.faulties.find(f => f.faultyType === coordination.faultyType)
      return faulty ? faulty.alias : 'Не определено'
    },
    getResponsibleEmployeeAssignTime: function (coordination) {
      if (this.employeeIdLocal) {
        return coordination.responsibleEmployees.find(emp => this.employeeIdLocal === emp.id).time
      } else {
        return null
      }
    },
    getReportHeader: function (report) {
      return `Проверка ${formatConfiguredTime(report.startReviewTime)}, отчет №${report.reportKey}`
    },
    getReviewerNote: function (report, coordination) {
      const faultyRecord = report.faulties.find(f => f.faultyType === coordination.faultyType)
      if (faultyRecord) {
        return faultyRecord.note
      } else {
        return ''
      }
    },
    calculateRevisionDeadlineTimes: function () {
      if (this.reports && this.reports.length) {
        this.reports.forEach(report => {
          report.coordinations.forEach(coordination => {
            this.calculateRevisionDeadlineTime(coordination)
          })
        })
      }
    },
    calculateRevisionDeadlineTime: function (coordination) {
      const responsibleAssignTime = this.getResponsibleEmployeeAssignTime(coordination)
      if (responsibleAssignTime) {
        const deadline = new Date(responsibleAssignTime)
        deadline.setDate(deadline.getDate() + 3)
        const remainingTime = deadline - new Date()
        this.$set(this.revisionDeadlineRemainingTime, coordination.recordId, remainingTime)
        this.$set(this.revisionDeadlineDateTime, coordination.recordId, deadline)
      } else {
        this.$set(this.revisionDeadlineDateTime, coordination.recordId, null)
        this.$set(this.revisionDeadlineRemainingTime, coordination.recordId, null)
      }
    },
    getRevisionDeadlineRemainingTimeFormatted: function (coordination) {
      const remainingTime = this.revisionDeadlineRemainingTime[coordination.recordId]
      if (remainingTime) {
        const remainingDays = Math.floor(remainingTime / (1000 * 60 * 60 * 24))
        const remainingHours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const remainingMinutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60))
        if (remainingTime > 0) {
          return `${remainingDays > 0 ? `${remainingDays} д. ` : ''}${remainingHours} ч. ${remainingMinutes} м.`
        } else {
          return 'Истек срок'
        }
      } else {
        return 'Не определен срок'
      }
    },
    getCoordinationNotesHistory: function (report, coordination) {
      return report.notesHistory.filter(n => n.recordId === coordination.recordId)
    },
    getRevisionStatusChangeTime: function (report, coordination) {
      const notes = this.getCoordinationNotesHistory(report, coordination).filter(n => n.eventType.includes('Подан запрос') || n.eventType.includes('Завершено рассмотрение'))
      return notes && notes.length ? formatConfiguredTime(notes[notes.length - 1].time) : ''
    },
    getRevisionResultText: function (report, coordination) {
      return coordination.revisionResult
    },
    getRevisionResultCommentText: function (report, coordination) {
      const notes = this.getCoordinationNotesHistory(report, coordination).filter(n => n.eventType.includes('Завершено рассмотрение'))
      return notes && notes.length ? notes[notes.length - 1].text : ''
    },
    getCoordinationRevisionRequestCreateTime: function (coordination, report) {
      const notes = this.getCoordinationNotesHistory(report, coordination).filter(n => n.eventType.includes('Подан запрос'))
      return notes && notes.length ? formatConfiguredTime(notes[notes.length - 1].time) : ''
    },
    getRevisionRequestText: function (report, coordination) {
      const notes = this.getCoordinationNotesHistory(report, coordination).filter(n => n.eventType.includes('Подан запрос') || n.eventType.includes('Изменен текст'))
      return notes && notes.length ? notes[notes.length - 1].text : ''
    },
    getRevisionRequestFilesGroup: function (coordination, report, type) {
      const files = this.getRevisionRequestFiles(coordination, report, type)
      const filesGroup = new FilesGroup({
        categoryKey: -1,
        readonly: true
      })
      files.forEach((file) => {
        filesGroup.pushFile(file)
      })
      return filesGroup
    },
    getRevisionRequestFiles: function (coordination, report, type) {
      const notes = this.getCoordinationNotesHistory(report, coordination).filter(n => n.eventType.includes('Подан запрос') || n.eventType.includes('Изменен текст'))
      return this.getFiles(notes && notes.length ? notes[notes.length - 1][type] : [])
    },
    getRevisionNoteFilesGroup: function (ids) {
      const files = this.getFiles(ids)
      const filesGroup = new FilesGroup({
        categoryKey: -1,
        readonly: true
      })
      files.forEach((file) => {
        filesGroup.pushFile(file)
      })
      return filesGroup
    },
    getFilesGroupToIgnoreDuplicate: function (reportId) {
      const filesGroup = new FilesGroup({
        categoryKey: -1,
        readonly: true
      })
      const report = this.reports.find(report => report.reportId === reportId)
      const ids = report.notesHistory.map(n => n.photos).flat().concat(report.notesHistory.map(n => n.files).flat()).filter(id => id)
      const files = this.getFiles(ids)
      files.forEach((file) => {
        filesGroup.pushFile(file)
      })
      return filesGroup
    },
    getFiles: function (ids) {
      if (ids) {
        return ids.map(id => {
          return {
            url: '/service/fileobj/read/' + id,
            smallUrl: '/service/delta/document/thumbnail/' + id + '/140/140',
            name: 'Качество работ на УДС' + '-' + id,
            id: id
          }
        })
      } else {
        return []
      }
    },
    onRequestRevision: function (coordination, report) {
      this.performRequestRevision({ recordId: coordination.recordId }, 'requestRevision', report.reportId)
    },
    onEditRevision: function (coordination, report) {
      const notes = this.getCoordinationNotesHistory(report, coordination).filter(n => n.eventType.includes('Подан запрос') || n.eventType.includes('Изменен текст'))
      const initialParams = {
        text: notes && notes.length ? notes[notes.length - 1].text : '',
        photos: notes && notes.length ? notes[notes.length - 1].photos : [],
        files: notes && notes.length ? notes[notes.length - 1].files : []
      }
      this.performRequestRevision({ recordId: coordination.recordId }, 'changeRevisionRequest', report.reportId, initialParams)
    },
    onCommentRevision: function (coordination, report) {
      this.performCommentRevision({ recordId: coordination.recordId }, 'commentRevisionByResponsible', report.reportId, coordination)
    },
    performAction: function (args, action, reportId) {
      const encodedArgs = encodeURIComponent(JSON.stringify(args))
      if (!encodedArgs) {
        return
      }
      const url = `/service/delta/workqualityreview/coordination/${action}?id=${reportId}${encodedArgs ? `&arguments=${encodedArgs}` : ''}`
      return axiosPost({
        url: url,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: response.data.change.text,
            progress: true,
            timeout: 3000
          })
          this.faulties = this.getFaulties()
        },
        onFailure: ''
      })
    },
    performRequestRevision (args, actionCode, reportId, initialParams = null) {
      const dialog = this.$d.dialog(this).show({
        noWrap: true,
        contentWidth: 700,
        maximizedOnNarrow: true,
        contentComponent: WorkQualityCoordinationDialogWithTextAndMedia,
        contentProps: {
          textLabel: 'Текст',
          title: 'Запрос на пересмотр замечания',
          reportId: reportId,
          isTextRequired: true,
          initialParams: initialParams,
          filesGroupToCheckForIgnoreDuplicate: this.getFilesGroupToIgnoreDuplicate(reportId),
          validateChangeInitialParams: actionCode === 'changeRevisionRequest'
        },
        componentHandlers: {
          continue: (data) => {
            args.text = data.text
            args.photos = data.photosIds
            args.files = data.documentsIds
            this.performAction(args, actionCode, reportId)
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    },
    performCommentRevision (args, actionCode, reportId) {
      const dialog = this.$d.dialog(this).show({
        noWrap: true,
        contentWidth: 700,
        maximizedOnNarrow: true,
        contentComponent: WorkQualityCoordinationDialogWithTextAndMedia,
        contentProps: {
          textLabel: 'Текст',
          title: 'Комментарий к пересмотру замечания',
          reportId: reportId,
          isTextRequired: true,
          filesGroupToCheckForIgnoreDuplicate: this.getFilesGroupToIgnoreDuplicate(reportId)
        },
        componentHandlers: {
          continue: (data) => {
            args.comment = data.text
            args.photos = data.photosIds
            args.files = data.documentsIds
            this.performAction(args, actionCode, reportId)
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    }
  }
}
